namespace $.$$ {
	export class $easyreels_i18n_switch extends $.$easyreels_i18n_switch {
		override value(next?: string) {
			return $easyreels_i18n_lang(next === 'ru' || next === 'en' ? next : undefined)
		}
	}
}
